import React from 'react';
import type {
  GetServerSidePropsContext,
  NextPage,
  InferGetServerSidePropsType
} from 'next';

import { Shelf } from 'types';

import Grid from '~/components/grid';

import styles from '~/styles/pages/public-shelves.module.scss';
import PageMetaData from '~/components/page-meta-data';
import { mapQueryBy, mapSortBy, searchWithFaceting, urlToTypesenseOptions } from 'sdk';
import { Typesense } from 'sdk/src/clients/typesense/react-query';

import useRouterSearchOptions from '~/lib/hooks/use-router-search-options';

const PublicShelvesPage: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = ({
  data,
  searchOptions
}) => {
  const searchQuery = useRouterSearchOptions({ searchOptions });

  const searchResults = Typesense<Shelf>().searchWithFaceting({
    props: searchQuery,
    reactQueryOptions: {
      keepPreviousData: false,
      initialData: data,
      enabled: Boolean(searchQuery),
    }
  });


  const renderHeader = () => {
    return (
      <div className={styles.header}>
        <h1 className={styles['header-title']}>Shelves on PangoBooks</h1>
        <p className={styles['header-subtext']}>
          Explore curated shelves from your fellow Pango readers
        </p>
      </div>
    );
  };

  return (
    <>
      <PageMetaData
        title='Shelves on PangoBooks | Explore curated shelves from your fellow Pango readers'
        description='Explore curated shelves from your fellow Pango readers'
      />
      <div className={styles['content-container']}>
        {renderHeader()}
        <Grid
          searchOptions={searchQuery}
          searchResults={searchResults as any}
          showFacets
          location='shelves'
        />
      </div>
    </>

  );
};


export const getServerSideProps = async ({ resolvedUrl }: GetServerSidePropsContext) => {
  let searchQuery = urlToTypesenseOptions({ url: resolvedUrl });

  searchQuery = {
    ...searchQuery,
    index: 'shelves',
    params: {
      ...searchQuery.params,
      query_by: mapQueryBy('shelves'),
      sort_by: mapSortBy('shelves_alltime_popularity'),
      filter_by: searchQuery.params?.filter_by ?? 'public:true&&title:!=Wishlist&&titlesCount:>0',
      facet_by: 'author_percents, categories_percents, hashtags',
      per_page: 30,
    },
    options: {}
  };

  const searchResults = await searchWithFaceting(searchQuery);


  return {
    props: {
      data: searchResults,
      searchOptions: searchQuery
    },
    notFound: !searchResults?.hits?.length
  };
};

export default PublicShelvesPage;
